import { render, staticRenderFns } from "./addressbook.vue?vue&type=template&id=748f11c0&scoped=true&"
import script from "./addressbook.vue?vue&type=script&lang=js&"
export * from "./addressbook.vue?vue&type=script&lang=js&"
import style0 from "./addressbook.vue?vue&type=style&index=0&id=748f11c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748f11c0",
  null
  
)

export default component.exports